import Vue from 'vue'
import VueRouter from 'vue-router'
import FlightView from '../views/flight/FlightView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:daymonth/:reference',
    name: 'flight',
    component: FlightView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
